import { render, staticRenderFns } from "./OrDivider.vue?vue&type=template&id=2fe671fa&scoped=true"
import script from "./OrDivider.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrDivider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrDivider.vue?vue&type=style&index=0&id=2fe671fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe671fa",
  null
  
)

export default component.exports